const getLanguageFromPath = (path) => {
    return path.split('/')[1] || null;
}

export {
    getLanguageFromPath,
}
